module.exports = __webpack_public_path__ + "static/media/smile-sad.615eb9cd.svg";